import { createAsyncThunk } from "@reduxjs/toolkit"
import { AddCustomerSubnodeType, FETCH_CUSTOMER_NODES, FETCH_CUSTOMER_PRICE_MODELS, MOVE_NODE, REMOVE_CUSTOMER_PRICE_MODEL, SAVE_PRICE_MODEL } from "../actionTypes/customer"
import { FetchFromBackoffice, PostBackoffice } from "../../utils/request"
import { CustomerNodeSummary, PriceModelEnvelope } from "../../pages/customers/pricemodel/types"
import { backofficeCommandURL } from "../../config"
import { postAsync } from "../../utils/ajax"
import { sec } from "../../utils/auth0Helper"
import { TopItem } from "../reducers/customer"




export const fetchCustomerPriceModels = createAsyncThunk(
    FETCH_CUSTOMER_PRICE_MODELS,
    async (customerId: {customerId: string | undefined}, thunkAPI) => {
      const response = await FetchFromBackoffice<PriceModelEnvelope[]>(`customers/${customerId.customerId}/price_models`)
    return response
    },
  )
  export const removePriceModel = createAsyncThunk(
    REMOVE_CUSTOMER_PRICE_MODEL,
    async (params: {params:{validFrom: string, id: string}}, thunkAPI) => {
       const response = await PostBackoffice(`cmd/node/price-model/delete`, params.params).then(  a => console.log(a))
    return response
    }
  )

  export const fetchCustomerNodes = createAsyncThunk(
    FETCH_CUSTOMER_NODES,
    async (thunkAPI) => {
      const response = await FetchFromBackoffice<CustomerNodeSummary[]>('customer/nodes')
    return response
    },
  )

  export const moveNode = createAsyncThunk(
    MOVE_NODE,
    async (params: {params:{id: string, fromNodeId: string, toNodeId: string}}, thunkAPI) => {
       const response = await PostBackoffice(`cmd/node/move`, params.params)
    return response
    }
  )

  export const addCustomerSubnodeThunk = createAsyncThunk(
    "ADD_CUSTOMER_SUBNODE",
    async (customerSubnode:AddCustomerSubnodeType, thunkAPI) => {
      let url = `${backofficeCommandURL()}/cmd/store/create`

      const command =
      {
        name: customerSubnode.name,
        invoice_AddressLine1: customerSubnode.invoice_AddressLine1,
        invoice_AddressLine2: customerSubnode.invoice_AddressLine2,
        invoice_PostalCode: customerSubnode.invoice_PostalCode,
        invoice_Locality: customerSubnode.invoice_Locality,
        visiting_AddressLine1: customerSubnode.visiting_AddressLine1,
        visiting_AddressLine2: customerSubnode.visiting_AddressLine2,
        visiting_PostalCode: customerSubnode.visiting_PostalCode,
        visiting_Locality: customerSubnode.visiting_Locality,
        location_Longitude: 0,
        location_Latitude: 0,
        companyId: customerSubnode.parentId,
        visiting_Country: customerSubnode.visiting_Country
      }
    
      const accessToken: string = await sec.getAccessTokenSilently()
      const response: Response = await postAsync( url, JSON.stringify(command), accessToken)
      if(response.status === 202){
        const json = await response.json();
        return { data: json.data};
      }
      return thunkAPI.rejectWithValue(response.status)

      // if (response && response.ok) {
      //   try {
      //     response.json().then(m => {
      //       const id: string = m?.Message as string
      //       getStore().dispatch({ type: 'CUSTOMER_SUBNODE_ADDED', id: id, customerSubnode: action.customerSubnode } as CustomerActionTypes)
      //     })
    
      //   } catch (e) {
      //     console.error('Error trying to process response Json:', e)
      //     yield put({ type: 'ADDING_CUSTOMER_SUBNODE_FAILED', customerSubnode: action.customerSubnode } as CustomerActionTypes)
      //   }
      // }
      // else {
      //   yield put({ type: 'ADDING_CUSTOMER_SUBNODE_FAILED', customerSubnode: action.customerSubnode } as CustomerActionTypes)
      // }
    }
  )
  export const savePriceModel = createAsyncThunk(
    SAVE_PRICE_MODEL,
    async (command:{model:any} , thunkAPI) => {        
        const arg:AddInitialFeeWithPerExecutionThresholds =
        {
          id: command.model.id,
          validFrom: command.model.date.toFormat("yyyy-MM-dd"),
          currency: command.model.currency,
          initialFee: command.model.initialCost as number,
          thresholds: command.model.threshHolds?.map((t) => {
            return {from: t.trigger as number, perExecution:t.cost as number } 
          })
      
        }
        const url = `${backofficeCommandURL()}${"cmd/node/price-model/add/initialfeewithperexecutionthresholds"}`;
        const token = await sec.getAccessTokenSilently()
        const response = await postAsync(url, JSON.stringify(arg), token)
        if(response.status === 202){
            return response
        }
        return thunkAPI.rejectWithValue(response.status)

    }
  )
  export const fetchTopCustomers = createAsyncThunk(
    "FETCH_TOP_CUSTOMERS",
    async (days: number, thunkAPI) => {
      const response = await FetchFromBackoffice<TopItem[]>(`dashboard/sales/customers/top/${days}`)
    return response
    },
  )

  export const fetchTopStores = createAsyncThunk(
    "FETCH_TOP_STORES",
    async (days: number, thunkAPI) => {
      const response = await FetchFromBackoffice<TopItem[]>(`dashboard/sales/stores/top/${days}`)
    return response
    },
  )

  type AddInitialFeeWithPerExecutionThresholds = {
    id:string,
    validFrom: string,
    currency: string,
    initialFee: number,
    thresholds:{from:number, perExecution:number}[]
  }
  




